export var FormTriggerType;
(function (FormTriggerType) {
    FormTriggerType[FormTriggerType["Click"] = 0] = "Click";
    FormTriggerType[FormTriggerType["Clear"] = 1] = "Clear";
    FormTriggerType[FormTriggerType["Exit"] = 2] = "Exit";
    FormTriggerType[FormTriggerType["Enter"] = 3] = "Enter";
    FormTriggerType[FormTriggerType["StoppedTyping"] = 4] = "StoppedTyping";
    FormTriggerType[FormTriggerType["ValueChanged"] = 5] = "ValueChanged";
    FormTriggerType[FormTriggerType["SelectionChanged"] = 6] = "SelectionChanged";
    FormTriggerType[FormTriggerType["RowAdded"] = 7] = "RowAdded";
    FormTriggerType[FormTriggerType["RowRemoved"] = 8] = "RowRemoved";
    FormTriggerType[FormTriggerType["TabChanged"] = 9] = "TabChanged";
})(FormTriggerType || (FormTriggerType = {}));
;
